module.exports = __webpack_public_path__ + "static/media/arrow_3.71587c28.svg";